import React from 'react';

const Clock = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='25'
      height='24'
      viewBox='0 0 25 24'
      fill='none'
    >
      <mask
        id='mask0_7799_16367'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='25'
        height='24'
      >
        <path d='M24.5 0H0.5V24H24.5V0Z' fill='white' />
      </mask>
      <g mask='url(#mask0_7799_16367)'>
        <path
          d='M12.5 20.625C7.74417 20.625 3.875 16.7558 3.875 12C3.875 7.24417 7.74417 3.375 12.5 3.375C17.2558 3.375 21.125 7.24417 21.125 12C21.125 16.7558 17.2558 20.625 12.5 20.625ZM12.5 5.625C8.985 5.625 6.125 8.485 6.125 12C6.125 15.515 8.985 18.375 12.5 18.375C16.015 18.375 18.875 15.515 18.875 12C18.875 8.485 16.015 5.625 12.5 5.625Z'
          fill='var(--colorIconPrimary)'
        />
        <path
          d='M20.3573 6.75C19.499 5.33333 18.199 4.20833 16.6406 3.59167L17.474 1.5C19.0631 2.13833 20.4498 3.17917 21.509 4.49167C21.6731 4.695 21.829 4.90417 21.9765 5.12L20.3573 6.75Z'
          fill='var(--colorIconPrimary)'
        />
        <path
          d='M3.9512 6.75C4.80953 5.33333 6.10953 4.20833 7.66786 3.59167L6.83453 1.5C5.24536 2.13833 3.8587 3.17917 2.79953 4.49167C2.63536 4.695 2.47953 4.90417 2.33203 5.12L3.9512 6.75Z'
          fill='var(--colorIconPrimary)'
        />
        <path
          d='M14.3079 15.05L11.3496 12.0917V7.5L13.5996 8.25V11.1583L16.6496 14.2083L14.3079 15.05Z'
          fill='var(--colorIconPrimary)'
        />
      </g>
    </svg>
  );
};

export default Clock;
